import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from "faker";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    plugins: {
        title: {
            display: false,
            text: 'Chart.js Bar Chart - Stacked',
        },
        legend: {
            display: false
        },
        datalabels: {
            display: false, //bu labelni yo'qotadi
            formatter: (value) => {
                return value + '%';
            },
            clamp: true,
            anchor: 'center',
            // align: 'center',
            // rotation: '-90',
            color: '#000000',
            labels: {
                title: {
                    font: {
                        weight: 'bold',
                        size: 10
                    }
                }
            }
        }
    },
    responsive: true,
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
};


const Chart10 = ({districts}) => {
    const labels = districts.map(d=>d.name.split(" ")[0])

    const data = {
        labels,
        datasets: [
            {
                // title: false,
                label: 'Limit',
                data: labels.map(() => faker.datatype.number({ min: 40, max: 100 })),
                backgroundColor: '#0e739e',
                stack: 'Stack 1'
            },
            {
                label: 'Amalda',
                data: labels.map(() => faker.datatype.number({ min: 10, max: 50 })),
                backgroundColor: '#63b7e8',
                stack: 'Stack 2'
            },
        ],
    };
    return (
        <div>
            <div className="chart1-top-box">
                <h4 className="title statics3-title m-0 px-2">Mavsum boshidan ishlatilgan suv miqdorlari (<span className="lower">mln.m<sup>3</sup> </span>)</h4>
                <ul className="chart1-top">
                    <li>
                        <div className="chart1-circle" style={{backgroundColor: "#465fcd"}}></div>
                        <h4>Limit </h4>
                    </li>
                    <li>
                        <div className="chart1-circle" style={{backgroundColor: "#9badee"}}></div>
                        <h4>Amalda </h4>
                    </li>
                </ul>
            </div>
            <Bar height={65} options={options} data={data} />
        </div>
    );
};

export default Chart10;